import { queryOptions, useQuery } from '@tanstack/react-query';

import { makeIsEnabled } from '@cast/utils';

import { apiClient } from '@cast/infrastructure-api';

const ORGANIZATION_WORKLOAD_EVENT_METRICS_QUERY_KEY =
  'organization-workload-event-metrics';

type OrganizationWorkloadEventMetricsQueryParams = {
  startTime?: string;
  endTime?: string;
  stepSeconds?: number;
  eventTypes?: string[];
  groupByManagedBy?: boolean;
  timeZone?: string;
  key: string;
  enabled?: boolean;
};

export const useOrganizationWorkloadEventMetricsQuery = ({
  key,
  enabled,
  endTime,
  eventTypes,
  groupByManagedBy,
  startTime,
  stepSeconds,
  timeZone,
}: OrganizationWorkloadEventMetricsQueryParams) => {
  const queryKey = [
    ORGANIZATION_WORKLOAD_EVENT_METRICS_QUERY_KEY,
    key,
    eventTypes,
    groupByManagedBy,
  ] as const;

  return useQuery(
    queryOptions({
      queryKey,
      queryFn: async () => {
        const { data } =
          await apiClient.costReport.getOrganizationWorkloadEventMetrics({
            startTime: startTime!,
            endTime: endTime!,
            stepSeconds,
            eventTypes,
            groupByManagedBy,
            timeZone,
          });
        return data?.series;
      },
      enabled: makeIsEnabled(!!startTime && !!endTime, enabled),
    })
  );
};
